import { useEffect } from 'react';
import DottedBackground from '../components/DottedBackground';
import { Footer } from '../components/Footer';
import { ReactComponent as SpygamesLogo } from 'src/shared/components/icons/spygames-logo.svg';
import { ReactComponent as QuestionMark } from 'src/shared/components/icons/not-found-question-mark.svg';

const PAGE_TITLE = 'Not Found | SPYGAMES';

const NotFoundPage = () => {
  useEffect(() => {
    document.title = PAGE_TITLE;
  }, []);

  return (
    <section className="w-screen h-screen bg-green-dark flex flex-col items-center font-aeonik text-white">
      <div className="w-full p-5 sm:p-10">
        <SpygamesLogo className="w-52 h-7.5 sm:w-78 sm:h-11 text-green-laser" />
      </div>
      <div className="sm:w-160 w-full flex-1 flex flex-col mt-10 relative gap-10 px-5">
        <div className="w-1.5 h-1.5 absolute left-0 top-0 hidden sm:inline rounded-1.25 bg-green-laser" />
        <div className="w-1.5 h-1.5 absolute right-0 top-0 hidden sm:inline rounded-1.25 bg-green-laser" />

        <h2 className="font-medium text-green-laser -mt-2.5 text-[2.75rem]/[2.75rem] sm:text-[4.375rem]/[4.375rem]">
          Oops!
        </h2>
        <div className="w-full flex gap-5">
          <div className="flex flex-col">
            <h3 className="font-medium text-white text-[2.125rem]/[2.4rem] sm:text-[3.125rem]/[3.5rem] m-0">
              The page you’re looking for must be undercover
            </h3>
            <p className="font-medium text-white mt-2.5">404 Error</p>
          </div>
          <div className="w-45 h-45">
            <QuestionMark className="h-30 sm:h-45" />
          </div>
        </div>
      </div>

      <DottedBackground className="mb-5 sm:mb-10" dotClassName="bg-green-laser" xCount={80} yCount={4} />
      <Footer />
    </section>
  );
};

export default NotFoundPage;
